import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import './App.css';
import ScrollToHashElement from './ScrollToHashElement';

// Homepage components
import AboutHyfye from './about'; 
import HeaderHyfye from "./header";
import BannerHyfye from "./banner";
import TokenHyfye from "./token";
import WorksHyfye from "./works";
import SaleHyfye from './sale';
import MobileHyfye from './mobile';
import InvestmentHyfye from './investment';
import RoadmapHyfye from './roadmap';
import TeamHyfye from './team';
import FAQHyfye from './faq';
import ClientHyfye from "./client";
import ContactHyfye from './contact';
import FooterHyfye from './footer';
import PartnerMarquee from "./partners"
import WhitepaperPage from './whitepaper';
import OfficialPages from "./official";

// Homepage layout
function FullHomePage() {
  return (
    <div className="App">
      {/* START LOADER */}
      <div id="loader-wrapper">
        <div id="loading-center-absolute">
          <div className="object" id="object_four"></div>
          <div className="object" id="object_three"></div>
          <div className="object" id="object_two"></div>
          <div className="object" id="object_one"></div>
        </div>
        <div className="loader-section section-left"></div>
        <div className="loader-section section-right"></div>
      </div>
      {/* END LOADER */}

      {/* HEADER */}
      <header className="header_wrap fixed-top">
        <HeaderHyfye />
      </header>

      {/* SECTIONS */}
      <BannerHyfye />
      <TokenHyfye />
      <AboutHyfye />
    
      <WorksHyfye /><PartnerMarquee/>
      <SaleHyfye />
     
      <MobileHyfye /> 
      <InvestmentHyfye />
      
      <RoadmapHyfye />

      <TeamHyfye />
     
      <FAQHyfye /> <PartnerMarquee/>
      <ClientHyfye />
      <ContactHyfye />

      {/* FOOTER */}
      <footer> 
        <FooterHyfye />
      </footer>

      <a href="#" className="scrollup btn-default">
        <i className="ion-ios-arrow-up"></i>
      </a>
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <ScrollToHashElement /> 
      <Routes>
        <Route path="/" element={<FullHomePage />} />
        <Route path="/pages" element={<OfficialPages />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
